import { cn } from "@repo/ui/lib/utils";
import { useEffect } from "react";
import { useAgentPanelOpen } from "@/app/providers/use-agent-panel";
import { AgentChat, useAgentChatContext } from "@/features/chat/components/agent-chat";
import { AgentChatSubjectBanner } from "@/features/chat/components/agent-chat/subject-banner";

/** Focus the input whenever the panel opens. Panel-specific behavior; lives outside the compound. */
function PanelAutoFocus({ open }: { open: boolean }) {
  const { meta } = useAgentChatContext();
  useEffect(() => {
    if (open) {
      const t = setTimeout(() => meta.inputRef.current?.focus(), 50);
      return () => clearTimeout(t);
    }
  }, [open, meta.inputRef]);
  return null;
}

export interface AgentChatPanelProps {
  onOpenHistory?: () => void;
}

export function AgentChatPanel({ onOpenHistory }: AgentChatPanelProps) {
  const open = useAgentPanelOpen();
  return (
    <div
      className={cn(
        // Gutter rail: sits outside SidebarInset, so it wears the sidebar backdrop
        // and runs the full viewport height rather than butting under AppHeader.
        "bg-sidebar text-sidebar-foreground overflow-hidden transition-[width] duration-200 ease-in-out",
        open ? "w-96" : "w-0",
      )}
    >
      <div className="w-96 h-full flex flex-col">
        <AgentChat.Root>
          <PanelAutoFocus open={open} />
          <AgentChat.Header>
            <AgentChat.NewChatButton />
            <AgentChat.HistoryButton onClick={onOpenHistory} />
            <AgentChat.DeleteButton />
            <AgentChat.ExpandButton className="ml-auto" />
          </AgentChat.Header>
          <AgentChat.Thread className="flex-1" />
          <div className="p-3">
            <AgentChatSubjectBanner />
          </div>
        </AgentChat.Root>
      </div>
    </div>
  );
}
